function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var PRE_ENTER = 0;
var ENTERING = 1;
var ENTERED = 2;
var PRE_EXIT = 3;
var EXITING = 4;
var EXITED = 5;
var UNMOUNTED = 6;
var STATUS = ['preEnter', 'entering', 'entered', 'preExit', 'exiting', 'exited', 'unmounted'];
var getState = function getState(status) {
  return {
    _s: status,
    status: STATUS[status],
    isEnter: status < PRE_EXIT,
    isMounted: status !== UNMOUNTED,
    isResolved: status === ENTERED || status > EXITING
  };
};
var startOrEnd = function startOrEnd(unmounted) {
  return unmounted ? UNMOUNTED : EXITED;
};
var getEndStatus = function getEndStatus(status, unmountOnExit) {
  switch (status) {
    case ENTERING:
    case PRE_ENTER:
      return ENTERED;
    case EXITING:
    case PRE_EXIT:
      return startOrEnd(unmountOnExit);
  }
};
var getTimeout = function getTimeout(timeout) {
  return _typeof(timeout) === 'object' ? [timeout.enter, timeout.exit] : [timeout, timeout];
};
var nextTick = function nextTick(transitState, status) {
  return setTimeout(function () {
    // Reading document.body.offsetTop can force browser to repaint before transition to the next state
    isNaN(document.body.offsetTop) || transitState(status + 1);
  }, 0);
};
export { ENTERED, ENTERING, EXITED, EXITING, PRE_ENTER, PRE_EXIT, STATUS, UNMOUNTED, getEndStatus, getState, getTimeout, nextTick, startOrEnd };